import React, { Component }   from 'react';
import { connect }            from 'react-redux';
import { ButtonToolbar,OverlayTrigger,Popover,Tooltip }                      from 'react-bootstrap';
import FlashCarregando        from '../../../container/FlashCarregando';
import {GetTarefasPerfil }    from '../../../actions/tarefaAction';
import { GetListaMenuTopo,
        GetListaSubMenuTopo,
        GetCheckSelect}  from '../../../actions/scopoAction';
import Missao_Professor_Lista   from './missao_professor_lista';
import { SetError }                   from '../../../actions/notificacaoAction';




class Tarefas_List_Professor extends Component {

    constructor(props){
      super(props);
       this.state = {disciplina:'Carregando...',
                    dis_id:this.props.match.params.dis_id,
                    tur_id:this.props.match.params.tur_id
                    }
     
    }
    componentWillMount() {
       
        this.props.GetTarefasPerfil(this.state.dis_id,this.state.tur_id).then((response) => {
            this.setState({load: true});
        }).catch((error) => {
            this.props.SetError(500);
        });

        this.props.GetListaMenuTopo([
          {action:true,nome:"Home",link:this.props.menu.home},
          {action:true,nome:"Unidade Curricular",link:this.props.menu.missao.home},
          {action:false,nome:this.props.menu.missao.nomeModulo}           
        ]);

        this.props.GetListaSubMenuTopo([
          {nome:"Ativo",link : null},
          {nome:"Inativo",link : 1},
        ]);

        this.props.GetCheckSelect(null);
    }

    render(){

        const checkSelect = {};
        switch (this.props.checkSelect) {
            case null:
                 checkSelect.acao = <Missao_Professor_Lista status={1} dis_id={this.state.dis_id}/>;       
            break;

            case 1:
                 checkSelect.acao = <Missao_Professor_Lista status={2} dis_id={this.state.dis_id}/>;     
            break;
        
            default:
            break;
        }

        const lef = {'float':'left','paddingRight':'5px'}
        var compartilhada =  "";
        if (this.props.disciplina) {

           if (this.props.disciplina.dis_compartilhada){
            var ar = this.props.disciplina.dis_compartilhada;
            const popoverTop = (
                <Tooltip id="tooltip">
                  <strong>Compartilhado com</strong>
                  <p></p>
                  {ar.map((elem,i)=>{
                   return <p key={i}>{elem}</p>
                  })} 
                </Tooltip>
              );

              var compartilhada = <ButtonToolbar style={lef}>
                                    <OverlayTrigger placement="top" overlay={popoverTop}>
                                      <span className="glyphicon glyphicon-warning-sign btn btn-warning btn-xs"></span>
                                     </OverlayTrigger>
                                   </ButtonToolbar>;                   
          } 
        }  


        return (
            <div>
           
                <div className="container-bg">
                    <div className="titulo-pages topo_conteudo">
                        <div className="titulo" >
                              <strong style={lef}> {!this.state.load?"Carregando...": this.props.disciplina.dis_nome}</strong>
                             {compartilhada}
                       </div>
                    </div>
                    { !this.state.load ? <FlashCarregando/>  :  checkSelect.acao} 
                </div>
           
            </div>
        );
    }
}

function mapStateToProps(state){

    return {
        session      : state.auth.session,
        listaTarefas : state.tarefaReducer.all_tarefas,
        disciplina : state.tarefaReducer.disciplina,
        checkSelect  : state.scopoReducer.checkSelect,
        menu         : state.configReducer.menu
        }

}

export default connect(mapStateToProps,{GetTarefasPerfil,GetListaMenuTopo,GetListaSubMenuTopo,GetCheckSelect,SetError})(Tarefas_List_Professor);


// WEBPACK FOOTER //
// ./src/components/professor/missoes/missao_professor.js